import { images } from "../constants";

const home = {
        image: images.home, // Home Image
        subtitle: "01 - 03 November, 2024 | London, UK", // Event Dates & Location
        headingPart1: "Inspiring",
        spanText: "Keynotes",
        headingPart2: "and Workshops",
        buttonText: "Buy Ticket",
        buttonLink: "Tickets",
};

export default home;